<template>
  <div v-if="isVisible" class="absolute w-full h-full z-90">
    <LoadingOverlay :visible="isVisible" :title="title" :progress="progress" />
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import { useLoadingService } from "@/services/LoadingService";

const loading = useLoadingService();
const { isVisible, title, progress } = storeToRefs(loading);
</script>
